"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reducers = void 0;
var redux_1 = require("redux");
var articles_1 = __importDefault(require("./slices/articles/articles"));
var banners_1 = __importDefault(require("./slices/banners/banners"));
var basket_1 = __importDefault(require("./slices/basket/basket"));
var basket_abandonment_1 = __importDefault(require("./slices/basket/basket_abandonment/basket_abandonment"));
var branch_1 = __importDefault(require("./slices/branch/branch"));
var category_1 = __importDefault(require("./slices/categories/category"));
var channel_1 = __importDefault(require("./slices/channels/channel"));
var client_1 = __importDefault(require("./slices/client/client"));
var condiment_1 = __importDefault(require("./slices/condiments/condiment"));
var console_1 = __importDefault(require("./slices/console"));
var customer_segment_1 = __importDefault(require("./slices/customer_segments/customer_segment"));
var customers_1 = __importDefault(require("./slices/customers/customers"));
var dashboard_1 = __importDefault(require("./slices/dashboard/dashboard"));
var datamap_1 = __importDefault(require("./slices/datamap/datamap"));
var deal_1 = __importDefault(require("./slices/deals/deal"));
var drivers_1 = __importDefault(require("./slices/driver/drivers"));
var entry_1 = __importDefault(require("./slices/entry"));
var faq_1 = __importDefault(require("./slices/faq/faq"));
var gift_1 = __importDefault(require("./slices/gift/gift"));
var heroconnect_1 = __importDefault(require("./slices/heroconnect/heroconnect"));
var buildings_1 = __importDefault(require("./slices/lets_cue/buildings/buildings"));
var meters_1 = __importDefault(require("./slices/lets_cue/meters/meters"));
var units_1 = __importDefault(require("./slices/lets_cue/units/units"));
var loyalty_1 = __importDefault(require("./slices/loyalty/loyalty"));
var main_1 = __importDefault(require("./slices/main"));
var marketplace_1 = __importDefault(require("./slices/marketplaces/marketplace"));
var menu_concepts_1 = __importDefault(require("./slices/menuConcepts/menu_concepts"));
var orders_1 = __importDefault(require("./slices/orders/orders"));
var parcels_1 = __importDefault(require("./slices/parcels/parcels"));
var payment_settings_1 = __importDefault(require("./slices/payment_settings/payment_settings"));
var product_1 = __importDefault(require("./slices/products/product"));
var product_attribute_1 = __importDefault(require("./slices/products/product_attribute/product_attribute"));
var product_attribute_family_1 = __importDefault(require("./slices/products/product_attribute_family/product_attribute_family"));
var product_attribute_updates_1 = __importDefault(require("./slices/products/product_attribute_updates/product_attribute_updates"));
var product_configuration_1 = __importDefault(require("./slices/products/product_configuration/product_configuration"));
var product_types_1 = __importDefault(require("./slices/products/product_types/product_types"));
var product_update_configurations_1 = __importDefault(require("./slices/products/product_update_configurations/product_update_configurations"));
var quote_1 = __importDefault(require("./slices/quotes/quote"));
var recommendation_1 = __importDefault(require("./slices/recommendations/recommendation"));
var registration_1 = __importDefault(require("./slices/registration"));
var reviews_1 = __importDefault(require("./slices/reviews/reviews"));
var scanScript_1 = __importDefault(require("./slices/scanScript/scanScript"));
var searchTerms_1 = __importDefault(require("./slices/searchTerms/searchTerms"));
var stock_replacement_1 = __importDefault(require("./slices/stockReplacement/stock_replacement"));
var store_front_1 = __importDefault(require("./slices/storeFront/store_front"));
var subscriptions_1 = __importDefault(require("./slices/subscriptions/subscriptions"));
var supplier_requests_1 = __importDefault(require("./slices/supplier_requests/supplier_requests"));
var themes_1 = __importDefault(require("./slices/themes/themes"));
var trips_1 = __importDefault(require("./slices/trips/trips"));
var user_vouchers_1 = __importDefault(require("./slices/user-vouchers/user-vouchers"));
var user_1 = __importDefault(require("./slices/user/user"));
var user_letsachieve_1 = __importDefault(require("./slices/user_letsachieve/user_letsachieve"));
var vouchers_1 = __importDefault(require("./slices/vouchers/vouchers"));
var waybill_1 = __importDefault(require("./slices/waybill/waybill"));
var workflow_1 = __importDefault(require("./slices/workflow/workflow"));
exports.reducers = (0, redux_1.combineReducers)({
    //TODO add more as needed
    mainState: main_1.default,
    userState: user_1.default,
    clientState: client_1.default,
    consoleState: console_1.default,
    entryState: entry_1.default,
    registrationState: registration_1.default,
    paymentSettingsState: payment_settings_1.default,
    subscriptionsState: subscriptions_1.default,
    branchState: branch_1.default,
    basketState: basket_1.default,
    productState: product_1.default,
    orderState: orders_1.default,
    parcelState: parcels_1.default,
    channelState: channel_1.default,
    categoryState: category_1.default,
    customerState: customers_1.default,
    driverState: drivers_1.default,
    loyaltyState: loyalty_1.default,
    heroconnectState: heroconnect_1.default,
    productTypeState: product_types_1.default,
    tripState: trips_1.default,
    dashboardState: dashboard_1.default,
    dealState: deal_1.default,
    scanScriptState: scanScript_1.default,
    stockReplacementState: stock_replacement_1.default,
    voucherState: vouchers_1.default,
    waybillState: waybill_1.default,
    workflowState: workflow_1.default,
    themeState: themes_1.default,
    storeFrontState: store_front_1.default,
    userVoucherState: user_vouchers_1.default,
    userLetsachieveState: user_letsachieve_1.default,
    searchTermsState: searchTerms_1.default,
    dataMapState: datamap_1.default,
    quoteState: quote_1.default,
    condimentState: condiment_1.default,
    giftState: gift_1.default,
    menuConceptState: menu_concepts_1.default,
    customerSegmentState: customer_segment_1.default,
    productAttributeState: product_attribute_1.default,
    productAttributeFamilyState: product_attribute_family_1.default,
    productConfigurationState: product_configuration_1.default,
    marketplaceState: marketplace_1.default,
    supplierRequestState: supplier_requests_1.default,
    recommendationState: recommendation_1.default,
    productAttributeUpdatesState: product_attribute_updates_1.default,
    productUpdateConfigState: product_update_configurations_1.default,
    buildingState: buildings_1.default,
    unitsState: units_1.default,
    metersState: meters_1.default,
    articlesState: articles_1.default,
    faqsState: faq_1.default,
    bannersState: banners_1.default,
    basketAbandonmentState: basket_abandonment_1.default,
    reviewsState: reviews_1.default,
});
